import React from 'react';
import RutubePlayer from './RutubePlayer';
import YouTubePlayer from './YouTubePlayer';
import './VideoPlayer.css';

export default function VideoPlayer(props) {
  const { platform } = props;

  if (platform === 'youtube') {
    return <YouTubePlayer {...props} />;
  }

  // По умолчанию Rutube (или можно добавить VK позже)
  return <RutubePlayer {...props} />;
}